module.exports = __webpack_public_path__ + "img/lauren.f9343546.jpg";